export var FETCHING_LOGIN_DETAILS = 'FETCHING_LOGIN_DETAILS';
export var FETCHING_LOGIN_DETAILS_DONE = 'FETCHING_LOGIN_DETAILS_DONE';
export var LOGOUT_USER = 'LOGOUT_USER';
export var OPEN_TIMEOUT_MODEL = 'OPEN_TIMEOUT_MODEL';
export var CLOSE_TIMEOUT_MODEL = 'CLOSE_TIMEOUT_MODEL';
export var USER_LOGGED_IN = 'USER_LOGGED_IN';
export var CLEAR_REDUX_STATE = 'CLEAR_REDUX_STATE';
export var LOGIN_MFA = 'LOGIN_MFA';
export var LOGIN_ERROR = 'LOGIN_ERROR;';
export var FETCH_MULTI_FACILITY_SUCCESS = 'FETCH_MULTI_FACILITY_SUCCESS';
